import * as React from 'react';
import { Icon } from './Icon';

export interface JumbotronProps {
    title: string;
    message: string;
    icon: string;
    children?: any;
}

export const Jumbotron = (props: JumbotronProps) => (
    <div className='information-box'>
        <div className='header'>
            <Icon name={props.icon} />
            <h4>{props.title}</h4>
        </div>
        <p>{props.message}</p>
        {props.children}
    </div>
);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/Jumbotron.tsx